import React from 'react';
import { Button } from './ui/Button';
import { Shield } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 px-4 overflow-hidden border-b-8 border-gold" data-id="element-36">
      {/* Subtle background pattern/texture could go here, keeping it clean for now */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-37">
        <div className="order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-38">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cream-dark border border-gold/50 rounded-full mb-6" data-id="element-39">
            <Shield className="w-5 h-5 text-gold" data-id="element-40" />
            <span className="text-sm font-semibold tracking-wider text-burgundy uppercase" data-id="element-41">
              Para su tranquilidad y la de su familia
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-42">
            Proteja su legado y evite que su familia herede un{' '}
            <span className="text-gold italic" data-id="element-43">"caos digital"</span>
          </h1>

          <h2 className="text-xl md:text-2xl text-charcoal-light mb-10 font-body font-medium" data-id="element-44">
            El sistema paso a paso para organizar sus cuentas, fotos y herencia
            digital en una sola tarde{' '}
            <span className="font-bold border-b-2 border-gold/30 pb-1" data-id="element-45">
              (especialmente diseñado para mujeres de 65+)
            </span>
            .
          </h2>

          <Button scrollTo="offer-section" className="w-full sm:w-auto text-xl py-5 px-10 shadow-warm" data-id="element-46">
            SÍ, QUIERO PROTEGER MI LEGADO AHORA
          </Button>

          <p className="mt-4 text-sm text-charcoal-light italic" data-id="element-47">
            Acceso instantáneo. Pago 100% seguro.
          </p>
        </div>

        <div className="order-1 lg:order-2 relative" data-id="element-48">
          <div className="absolute inset-0 bg-gold/20 rounded-lg transform translate-x-4 translate-y-4" data-id="element-49"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fLDFBvNFCUkMHgAMtEyaNk/Legado_Digital_Seguro.png" alt="Libro y dispositivos mostrando Legado Digital Seguro" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border-4 border-white" data-id="element-50" />
        </div>
      </div>
    </section>;
}